export const getColSizes = (count: number) => {
  switch (count) {
    case 1:
      return { xs: 24, md: 12 };
    case 2:
      return { xs: 12, md: 6 };
    case 3:
      return { xs: 8, md: 4 };
    default:
      return { xs: 6, md: 3 };
  }
};
